import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type EfficiencyProps = MeasurementProps<'electricConsumption'>;

/**
 * How far an electric vehicle goes on its energy, as kWh per 100 km or miles per kWh.
 *
 * Reciprocals of each other, as with fuel economy.
 */
const Efficiency = createMeasurement('electricConsumption', 'Efficiency');

export default Efficiency;
